import React, { useEffect } from 'react';
import useQuery from '../../utils/use-query';
import { useLocation } from 'react-router-dom';

function Auth() {
  const query = useQuery();
  const location = useLocation();
  useEffect(() => {
    localStorage.setItem('token', query.get('token'));
    window.location.href = query.get('callback');
    return () => { };
  }, [location.pathname, query]);
  return <div>Loading!</div>;
}

export default Auth;
